import { duration } from 'moment';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { ProjectId, UserId } from 'api/models';
import { ProjectAPI, ProjectMembers } from 'api/project';
import { logger } from 'services';
import { setLoaded, setLoading } from 'stores/memberships/actions';
import { ProjectPermissionSetType } from 'stores/permission-sets';
import { cache } from 'utils/cache';

export const useLoadMembership = (): ((
  project: ProjectId,
) => Promise<ProjectMembers | undefined>) => {
  const dispatch = useDispatch();
  const getMembers = useMemo(
    () => cache(ProjectAPI.getMembers, duration(5, 'seconds').asMilliseconds()),
    [],
  );

  return useCallback(
    async (projectId: ProjectId): Promise<ProjectMembers | undefined> => {
      dispatch(setLoading(projectId));
      try {
        const response = await getMembers(projectId[1]);
        const { members, teamList } = response;

        await dispatch(
          setLoaded({
            projectId,
            memberships: members.map(
              ({
                user: { userId },
                permissionSet: { permissionSetType: memberType },
                joinedAt,
              }) => ({
                userId: UserId(userId),
                memberType: memberType as unknown as ProjectPermissionSetType,
                joinedAt,
              }),
            ),
            placeholders: teamList,
          }),
        );

        return response;
      } catch (error) {
        logger.error('get members failed', { error });

        return undefined;
      }
    },
    [dispatch, getMembers],
  );
};
